<template lang="pug">
.messages
  Message(v-for="({ type, text, persist }, id) in allMessages" :type="type" :text="text" :persist="persist" :key="id")
</template>

<script>
  import Message from './message.vue'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      Message
    },

    props: {
      messages: {
        type: Array,
        required: true
      }
    },

    computed: mapGetters('messages', { allMessages: 'messages' }),

    mounted() {
      this.messages.forEach(message => {
        this.$store.commit('messages/ADD', message);
      })
    }
  }
</script>

<style lang="scss" scoped>
  .messages {
    position: fixed;
    display: flex;
    justify-content: center;
    flex-direction: column;
    gap: 0;
    top: 0;
    left: 0;
    width: 100%;
    // The reason for the weird pairing of margin vertical and padding for horizontal here is
    // because horizontal margin throws off the centering, and vertical padding creates a
    // transparent click-blocking layer at the top of the page.
    margin: 20px 0;
    padding: 0 20px;

    > :not(:last-child) {
      display: none;
    }
  }
</style>
